const utils = {
    intToEuros: (i) => {
        let p = (Math.round(i * 100)/100).toString();        
        p = p.replace(/(\.[0-9])$/, '$10').replace(/^([^.]+)$/, '$1.00');
        return p + '\u00A0€';
    }
};
export default utils;